// Get Tax Class List
export const UPLOAD_PDF_AND_SEND_EMAIL_REQUEST =
  'UPLOAD_PDF_AND_SEND_EMAIL_REQUEST';
export const UPLOAD_PDF_AND_SEND_EMAIL_SUCCESS =
  'UPLOAD_PDF_AND_SEND_EMAIL_SUCCESS';
export const UPLOAD_PDF_AND_SEND_EMAIL_FAIL = 'UPLOAD_PDF_AND_SEND_EMAIL_FAIL';
